// // components/reports/leadReportLayer.jsx
// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import { 
//   FiFilter, 
//   FiSearch, 
//   FiX, 
//   FiChevronDown, 
//   FiChevronUp,
//   FiUsers,
//   FiPhoneCall,
//   FiClock,
//   FiTrendingUp,
//   FiCalendar,
//   FiUser,
//   FiTag,
//   FiMail,
//   FiPhone,
//   FiStar,
//   FiMessageCircle,
//   FiChevronLeft,
//   FiChevronRight,
//   FiChevronsLeft,
//   FiChevronsRight,
//   FiDownload,
//   FiRefreshCw,
//   FiEye,
//   FiUserCheck,
//   FiUserX
// } from "react-icons/fi";
// import { getLeadsWithParams } from "../../services/leadReportService";
// import "./LeadReportLayer.css";
// import { getCategories } from "../../services/categoryService";

// const LeadReportLayer = () => {
//   const [data, setData] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [summary, setSummary] = useState({});
//   const [teamMembers, setTeamMembers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [expandedRow, setExpandedRow] = useState(null);
//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showFilters, setShowFilters] = useState(true);
//   const [viewMode, setViewMode] = useState("table"); // table, grid

//   const [filters, setFilters] = useState({
//     from: "",
//     to: "",
//     status: "",
//     user_id: "",
//     tm_id: "",
//     lead_id: "",
//     user_name: "",
//     category: "",
//   });


//   const loadCategories = async () => {
//   try {
//     const res = await getCategories();

//     if (res.status === "success") {
//       setCategories(res.data || []);
//     }
//   } catch (error) {
//     console.error("Category load error:", error);
//   }
// };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//     setPage(1);
//   };

//   const normalizeStatus = (str) => {
//     if (!str) return "";
//     return str.toLowerCase().replace(/\s+/g, "_");
//   };

//   const formatDuration = (seconds) => {
//     if (!seconds) return "00:00:00";
//     const hrs = Math.floor(seconds / 3600);
//     const mins = Math.floor((seconds % 3600) / 60);
//     const secs = seconds % 60;
//     return `${hrs.toString().padStart(2, "0")}:${mins
//       .toString()
//       .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
//   };

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const params = {};

//       if (filters.from && filters.to) {
//         params.from = new Date(filters.from).toISOString().split("T")[0];
//         params.to = new Date(filters.to).toISOString().split("T")[0];
//       }

//       if (filters.from && !filters.to) params.from = filters.from;
//       if (filters.to && !filters.from) params.to = filters.to;
//       if (filters.status) params.status = normalizeStatus(filters.status);
//       if (filters.user_id) params.user_id = filters.user_id;
//       if (filters.tm_id) params.tm_id = filters.tm_id;
//       if (filters.lead_id) params.lead_id = filters.lead_id;
//       if (filters.user_name) params.user_name = filters.user_name;
//       if (filters.category) params.category = filters.category;

//       if (searchTerm) params.search = searchTerm;

//       const res = await getLeadsWithParams(params);

//       setData(res?.data || []);
//       setSummary(res?.summary || {});
//       setTeamMembers(res?.summary?.team_members || []);
//       setExpandedRow(null);
//       setPage(1);
//     } catch (err) {
//       console.error("Fetch error:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, [filters, searchTerm]);

//   useEffect(() => {
//     const timeoutId = setTimeout(() => {
//       fetchData();
//     }, 500);
//     return () => clearTimeout(timeoutId);
//   }, [fetchData]);
//   useEffect(() => {
//   loadCategories();
// }, []);

//   const toggleRow = (id) => {
//     setExpandedRow((prev) => (prev === id ? null : id));
//   };

//   const getStatusClass = (status) => {
//     if (!status) return "status-default";
//     const statusMap = {
//       new: "status-new",
//       contacted: "status-contacted",
//       interested: "status-interested",
//       not_interested: "status-not_interested",
//       call_back: "status-call_back",
//       demo_scheduled: "status-demo_scheduled",
//       follow_up: "status-follow_up",
//       negotiation: "status-negotiation",
//       decision_pending: "status-decision_pending",
//     };
//     return statusMap[status.toLowerCase()] || "status-default";
//   };

//   const getStatusIcon = (status) => {
//     if (!status) return <FiUser />;
//     const icons = {
//       new: <FiUserCheck />,
//       contacted: <FiPhoneCall />,
//       interested: <FiTrendingUp />,
//       not_interested: <FiUserX />,
//       call_back: <FiRefreshCw />,
//       demo_scheduled: <FiCalendar />,
//     };
//     return icons[status.toLowerCase()] || <FiTag />;
//   };

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "-";
//     try {
//       const date = new Date(dateStr.replace(" ", "T"));
//       return date.toLocaleString("en-GB", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//         hour: "2-digit",
//         minute: "2-digit",
//       });
//     } catch {
//       return dateStr;
//     }
//   };

//  const filteredData = useMemo(() => {
//   const term = searchTerm.toLowerCase().trim();

//   return data.filter((lead) => {
//     let matchesSearch = true;
//     let matchesCategory = true;

//     // SEARCH
//     if (term) {
//       matchesSearch =
//         lead.name?.toLowerCase().includes(term) ||
//         lead.phone?.includes(term) ||
//         lead.email?.toLowerCase().includes(term) ||
//         lead.id?.toString().includes(term);
//     }

//     // CATEGORY FILTER
//     if (filters.category) {
//       matchesCategory =
//         lead.category_name?.toLowerCase() ===
//         filters.category.toLowerCase();
//     }

//     return matchesSearch && matchesCategory;
//   });
// }, [data, searchTerm, filters.category]);

//   const totalPages = Math.ceil(filteredData.length / limit);
//   const paginatedData = useMemo(() => {
//     const start = (page - 1) * limit;
//     return filteredData.slice(start, start + limit);
//   }, [filteredData, page, limit]);

//   useEffect(() => {
//     setPage(1);
//   }, [limit]);

//   const clearFilters = () => {
//     setFilters({
//       from: "",
//       to: "",
//       status: "",
//       user_id: "",
//       tm_id: "",
//       lead_id: "",
//       user_name: "",
//       category: "",
//     });
//     setSearchTerm("");
//     setPage(1);
//   };

//   const exportToCSV = () => {
//     const headers = ["ID", "Name", "Phone", "Email", "Status", "Created At", "Discussion", "Remark"];
//     const csvData = filteredData.map(lead => [
//       lead.id,
//       lead.name,
//       lead.phone,
//       lead.email,
//       lead.status,
//       lead.created_at,
//       lead.discussion || "",
//       lead.remark || ""
//     ]);
    
//     const csvContent = [headers, ...csvData].map(row => row.join(",")).join("\n");
//     const blob = new Blob([csvContent], { type: "text/csv" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `leads_report_${new Date().toISOString().split("T")[0]}.csv`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   const getActiveFiltersCount = () => {
//     return Object.values(filters).filter(v => v && v !== "").length + (searchTerm ? 1 : 0);
//   };

//   return (
//     <div className="lead-container">
//       {/* Header Section */}
//       <div className="lead-header">
//         <div className="header-title">
//           <h3>Leads Management Dashboard</h3>
//           <p className="subtitle">Track and manage all your leads in one place</p>
//         </div>
//         <div className="header-actions">
//           {/* <button className="btn-export" onClick={exportToCSV}>
//             <FiDownload /> Export
//           </button> */}
//           <button className="btn-refresh" onClick={fetchData}>
//             <FiRefreshCw /> Refresh
//           </button>
//         </div>
//       </div>

//       {/* Search Bar */}
//       <div className="search-section">
//         <div className="search-wrapper">
//           <FiSearch className="search-icon" />
//           <input
//             type="text"
//             placeholder="Search by name, phone, email or lead ID..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//           {searchTerm && (
//             <button className="clear-search" onClick={() => setSearchTerm("")}>
//               <FiX />
//             </button>
//           )}
//         </div>
//         <button 
//           className={`filter-toggle ${showFilters ? "active" : ""}`}
//           onClick={() => setShowFilters(!showFilters)}
//         >
//           <FiFilter /> Filters
//           {getActiveFiltersCount() > 0 && (
//             <span className="filter-badge">{getActiveFiltersCount()}</span>
//           )}
//         </button>
  
//       </div>

//       {/* Filters Section */}
//       {showFilters && (
//         <div className="filters-section">
//           <div className="filters-grid">
//             <div className="filter-group">
//               <FiCalendar className="filter-icon" />
//               <input
//                 type="date"
//                 name="from"
//                 value={filters.from}
//                 onChange={handleFilterChange}
//                 placeholder="From Date"
//               />
//             </div>
//             <div className="filter-group">
//               <FiCalendar className="filter-icon" />
//               <input
//                 type="date"
//                 name="to"
//                 value={filters.to}
//                 onChange={handleFilterChange}
//                 placeholder="To Date"
//               />
//             </div>
//             {/* <div className="filter-group">
//               <FiUser className="filter-icon" />
//               <input
//                 type="text"
//                 name="user_id"
//                 placeholder="Sales User ID"
//                 value={filters.user_id}
//                 onChange={handleFilterChange}
//               />
//             </div> */}
//             {/* <div className="filter-group">
//               <FiUsers className="filter-icon" />
//               <input
//                 type="text"
//                 name="tm_id"
//                 placeholder="TM ID"
//                 value={filters.tm_id}
//                 onChange={handleFilterChange}
//               />
//             </div> */}
//             {/* <div className="filter-group">
//               <FiTag className="filter-icon" />
//               <input
//                 type="text"
//                 name="lead_id"
//                 placeholder="Lead ID"
//                 value={filters.lead_id}
//                 onChange={handleFilterChange}
//               />
//             </div> */}
//             <div className="filter-group">
//               <FiUser className="filter-icon" />
//               <input
//                 type="text"
//                 name="user_name"
//                 placeholder="User Name"
//                 value={filters.user_name}
//                 onChange={handleFilterChange}
//               />
//             </div>
//             <div className="filter-group">
//   <FiTag className="filter-icon" />

//   <select
//     name="category"
//     value={filters.category}
//     onChange={handleFilterChange}
//   >
//     <option value="">All Categories</option>

//     {categories.map((cat) => (
//       <option key={cat.id} value={cat.name}>
//         {cat.name}
//       </option>
//     ))}
//   </select>
// </div>
//             <div className="filter-group">
//               <FiTag className="filter-icon" />
//               <select name="status" value={filters.status} onChange={handleFilterChange}>
//                 <option value="">All Status</option>
//                 <option value="new">New</option>
//                 <option value="contacted">Contacted</option>
//                 <option value="interested">Interested</option>
//                 <option value="not_interested">Not Interested</option>
//                 <option value="call_back">Call Back</option>
//                 <option value="demo_scheduled">Demo Scheduled</option>
//                 <option value="follow_up">Follow Up</option>
//                 <option value="negotiation">Negotiation</option>
//                 <option value="decision_pending">Decision Pending</option>
//               </select>
//             </div>
//           </div>
//           <div className="filter-actions">
//             <button className="btn-apply" onClick={fetchData} disabled={loading}>
//               {loading ? "Loading..." : "Apply Filters"}
//             </button>
//             <button className="btn-clear" onClick={clearFilters}>
//               Clear All
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Team Members Section */}
//       {teamMembers.length > 0 && (
//         <div className="team-section">
//           <div className="team-header">
//             <FiUsers className="team-icon" />
//             <span>Team Members ({teamMembers.length})</span>
//           </div>
//           <div className="team-members">
//             {teamMembers.map((member, idx) => (
//               <div key={idx} className={`team-badge role-${member.role}`}>
//                 {member.name} ({member.role})
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Summary Cards */}
//       <div className="summary-cards">
//         <div className="summary-card">
//           <div className="card-icon lead-icon">
//             <FiUsers />
//           </div>
//           <div className="card-info">
//             <span className="card-label">Total Leads</span>
//             <span className="card-value">{summary.total_leads || 0}</span>
//           </div>
//         </div>
//         <div className="summary-card">
//           <div className="card-icon call-icon">
//             <FiPhoneCall />
//           </div>
//           <div className="card-info">
//             <span className="card-label">Total Calls</span>
//             <span className="card-value">{summary.total_calls_count || 0}</span>
//           </div>
//         </div>
//         <div className="summary-card">
//           <div className="card-icon time-icon">
//             <FiClock />
//           </div>
//           <div className="card-info">
//             <span className="card-label">Total Duration</span>
//             <span className="card-value">{summary.total_duration_formatted || "00:00:00"}</span>
//           </div>
//         </div>
//         <div className="summary-card">
//           <div className="card-icon team-icon">
//             <FiUsers />
//           </div>
//           <div className="card-info">
//             <span className="card-label">Team Size</span>
//             <span className="card-value">{summary.team_size || 0}</span>
//           </div>
//         </div>
//       </div>

//       {/* Status Breakdown */}
//       {/* {summary.status_breakdown && Object.keys(summary.status_breakdown).length > 0 && (
//         <div className="status-breakdown">
//           <h4>Status Breakdown</h4>
//           <div className="status-chips">
//             {Object.entries(summary.status_breakdown).map(([status, count]) => (
//               <div key={status} className={`status-chip ${getStatusClass(status)}`}>
//                 {getStatusIcon(status)}
//                 <span>{status || "Empty"}</span>
//                 <strong>{count}</strong>
//               </div>
//             ))}
//           </div>
//         </div>
//       )} */}

//       {/* Limit Selector */}
//       <div className="table-controls">
//         <div className="entries-selector">
//           <label>Show</label>
//           <select value={limit} onChange={(e) => setLimit(Number(e.target.value))}>
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//             <option value={100}>100</option>
//           </select>
//           <label>entries</label>
//         </div>
//         <div className="record-info">
//           Showing {paginatedData.length} of {filteredData.length} leads
//         </div>
//       </div>

//       {/* Main Content */}
//       {loading ? (
//         <div className="loading-state">
//           <div className="spinner"></div>
//           <p>Loading leads...</p>
//         </div>
//       ) : viewMode === "table" ? (
//         <div className="table-responsive">
//           <table className="report-table">
//             <thead>
//               <tr>
//                 <th></th>
//                 <th>ID</th>
//                 <th>Lead Information</th>
//                 <th>Contact</th>
//                 <th>Status</th>
//                 <th>Last Follow-up</th>
//                 <th>Created</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData.length > 0 ? (
//                 paginatedData.map((lead) => (
//                   <React.Fragment key={lead.id}>
//                     <tr className={expandedRow === lead.id ? "expanded" : ""}>
//                       <td>
//                         <button className="expand-btn" onClick={() => toggleRow(lead.id)}>
//                           {expandedRow === lead.id ? <FiChevronUp /> : <FiChevronDown />}
//                         </button>
//                       </td>
//                       <td className="lead-id">#{lead.id}</td>
//                       <td>
//                         <div className="lead-info">
//                           <strong>{lead.name || "-"}</strong>
//                           {lead.is_high_profile === 1 && <span className="premium-badge">Premium</span>}
//                           {lead.source && <span className="source-badge">{lead.source}</span>}
//                         </div>
//                       </td>
//                       <td>
//                         <div className="contact-info">
//                           <div><FiPhone /> {lead.phone || "-"}</div>
//                           <div><FiMail /> {lead.email || "-"}</div>
//                         </div>
//                       </td>
//                       <td>
//                         <span className={`status-badge ${getStatusClass(lead.status)}`}>
//                           {getStatusIcon(lead.status)}
//                           {lead.status || "New"}
//                         </span>
//                       </td>
//                  <td>
//   <div>
//     <strong>Text:</strong>{" "}
//     {lead.last_followup?.text || "-"}
//   </div>

//   <div style={{ marginTop: "4px" }}>
//     <strong>Note:</strong>{" "}
//     {lead.last_followup?.note || "-"}
//   </div>
// </td>
//                       <td className="date-cell">{formatDate(lead.created_at)}</td>
//                     </tr>
//                 {expandedRow === lead.id && (
//   <tr className="details-row">
//     <td colSpan="6">
//       <div className="lead-details">

//         {/* Discussion & Remarks */}
//         <div className="details-section">
//           <strong>
//             <FiMessageCircle /> Discussion & Remarks
//           </strong>

//           <p>
//             <strong>Discussion:</strong>{" "}
//             {lead.discussion || "-"}
//           </p>

//           <p>
//             <strong>Remark:</strong>{" "}
//             {lead.remark || "-"}
//           </p>
//         </div>

//         {/* Follow-up Information */}
//         <div className="details-section">
//           <strong>
//             <FiCalendar /> Follow-up Information
//           </strong>

//           <p>
//             <strong>Follow-up Date:</strong>{" "}
//             {lead.followup_date || "-"}
//           </p>

//           <p>
//             <strong>Status:</strong>{" "}
//             {lead.followup_status || "-"}
//           </p>
//         </div>

//         {/* Assigned Users */}
//         <div className="details-section">
//           <strong>
//             <FiUsers /> Assigned To
//           </strong>

//           {lead.assigned_to?.length > 0 ? (
//             lead.assigned_to.map((u, i) => (
//               <div key={i} className="assigned-user">
//                 <span className={`role-badge ${u.type}`}>
//                   {u.type}
//                 </span>

//                 <span>{u.name}</span>

//                 <span className="user-email">
//                   ({u.email})
//                 </span>
//               </div>
//             ))
//           ) : (
//             <p>-</p>
//           )}
//         </div>

//         {/* Last Follow-up */}
//         {lead.last_followup && (
//           <div className="details-section">
//             <strong>
//               <FiMessageCircle /> Last Follow-up
//             </strong>

//             <p>
//               <strong>Text:</strong>{" "}
//               {lead.last_followup.text || "-"}
//             </p>

//             <p>
//               <strong>Note:</strong>{" "}
//               {lead.last_followup.note || "-"}
//             </p>

//             <p>
//               <strong>Follow-up Date:</strong>{" "}
//               {lead.last_followup.date
//                 ? formatDate(lead.last_followup.date)
//                 : "-"}
//             </p>
//           </div>
//         )}

//       </div>
//     </td>
//   </tr>
// )}
//                   </React.Fragment>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="6" className="no-data">
//                     <FiSearch />
//                     <p>No leads found</p>
//                     <span>Try adjusting your filters or search criteria</span>
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <div className="grid-view">
//           {paginatedData.length > 0 ? (
//             paginatedData.map((lead) => (
//               <div key={lead.id} className="lead-card">
//                 <div className="card-header">
//                   <div className="lead-name">
//                     <h4>{lead.name || "-"}</h4>
//                     {lead.is_high_profile === 1 && <span className="premium-badge">Premium</span>}
//                   </div>
//                   <button className="card-expand" onClick={() => toggleRow(lead.id)}>
//                     {expandedRow === lead.id ? <FiChevronUp /> : <FiChevronDown />}
//                   </button>
//                 </div>
//                 <div className="card-body">
//                   <div className="card-detail">
//                     <FiPhone />
//                     <span>{lead.phone || "-"}</span>
//                   </div>
//                   <div className="card-detail">
//                     <FiMail />
//                     <span>{lead.email || "-"}</span>
//                   </div>
//                   <div className="card-detail">
//                     <FiTag />
//                     <span className={`status-badge ${getStatusClass(lead.status)}`}>
//                       {lead.status || "New"}
//                     </span>
//                   </div>
//                   <div className="card-detail">
//                     <FiCalendar />
//                     <span>{formatDate(lead.created_at)}</span>
//                   </div>
//                 </div>
//                 {expandedRow === lead.id && (
//                   <div className="card-footer">
//                     <div className="card-section">
//                       <strong>Discussion:</strong>
//                       <p>{lead.discussion || "-"}</p>
//                     </div>
//                     <div className="card-section">
//                       <strong>Remark:</strong>
//                       <p>{lead.remark || "-"}</p>
//                     </div>
//                     <div className="card-section">
//                       <strong>Assigned To:</strong>
//                       {lead.assigned_to?.map((u, i) => (
//                         <div key={i}>{u.name} ({u.type})</div>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             ))
//           ) : (
//             <div className="no-data">
//               <FiSearch />
//               <p>No leads found</p>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="pagination">
//           <button onClick={() => setPage(1)} disabled={page === 1}>
//             <FiChevronsLeft />
//           </button>
//           <button onClick={() => setPage(page - 1)} disabled={page === 1}>
//             <FiChevronLeft />
//           </button>
//           <span className="page-info">
//             Page {page} of {totalPages}
//           </span>
//           <button onClick={() => setPage(page + 1)} disabled={page === totalPages}>
//             <FiChevronRight />
//           </button>
//           <button onClick={() => setPage(totalPages)} disabled={page === totalPages}>
//             <FiChevronsRight />
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default LeadReportLayer;


// components/reports/leadReportLayer.jsx
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { 
  FiFilter, 
  FiSearch, 
  FiX, 
  FiChevronDown, 
  FiChevronUp,
  FiUsers,
  FiPhoneCall,
  FiClock,
  FiTrendingUp,
  FiCalendar,
  FiUser,
  FiTag,
  FiMail,
  FiPhone,
  FiMessageCircle,
  FiChevronLeft,
  FiChevronRight,
  FiChevronsLeft,
  FiChevronsRight,
  FiDownload,
  FiRefreshCw,
  FiEye,
  FiUserCheck,
  FiUserX
} from "react-icons/fi";
import { getLeadsWithParams } from "../../services/leadReportService";
import { getLeadStatuses } from "../../services/leadService";
import "./LeadReportLayer.css";
import { getCategories } from "../../services/categoryService";

const LeadReportLayer = () => {
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [summary, setSummary] = useState({});
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilters, setShowFilters] = useState(true);

  const [filters, setFilters] = useState({
    from: "",
    to: "",
    status: "",
    user_id: "",
    tm_id: "",
    lead_id: "",
    user_name: "",
    category: "",
    source: "",
  });

  const [statuses, setStatuses] = useState([]);

  const loadData = async () => {
    try {
      const res = await getCategories();
      if (res.status === "success") {
        setCategories(res.data || []);
      }
      
      const statRes = await getLeadStatuses();
      if (statRes.status === "success") {
        setStatuses(statRes.data || []);
      }
    } catch (error) {
      console.error("Data load error:", error);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
    setPage(1);
  };

  const normalizeStatus = (str) => {
    if (!str) return "";
    return str.toLowerCase().replace(/\s+/g, "_");
  };

  const formatDuration = (seconds) => {
    if (!seconds) return "00:00:00";
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};

      if (filters.from && filters.to) {
        params.from = new Date(filters.from).toISOString().split("T")[0];
        params.to = new Date(filters.to).toISOString().split("T")[0];
      }

      if (filters.from && !filters.to) params.from = filters.from;
      if (filters.to && !filters.from) params.to = filters.to;
      if (filters.status) params.status = normalizeStatus(filters.status);
      if (filters.user_id) params.user_id = filters.user_id;
      if (filters.tm_id) params.tm_id = filters.tm_id;
      if (filters.lead_id) params.lead_id = filters.lead_id;
      if (filters.user_name) params.user_name = filters.user_name;
      if (filters.category) params.category = filters.category;
      if (filters.source) params.source = filters.source;

      if (searchTerm) params.search = searchTerm;

      const res = await getLeadsWithParams(params);

      setData(res?.data || []);
      setSummary(res?.summary || {});
      setTeamMembers(res?.summary?.team_members || []);
      setPage(1);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  }, [filters, searchTerm]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchData();
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [fetchData]);

  useEffect(() => {
    loadData();
  }, []);

  const getStatusClass = (status) => {
    if (!status) return "status-default";
    const statusMap = {
      new: "status-new",
      contacted: "status-contacted",
      interested: "status-interested",
      not_interested: "status-not_interested",
      call_back: "status-call_back",
      demo_scheduled: "status-demo_scheduled",
      follow_up: "status-follow_up",
      negotiation: "status-negotiation",
      decision_pending: "status-decision_pending",
    };
    return statusMap[status.toLowerCase()] || "status-default";
  };

  const formatStatusLabel = (status) => {
    if (!status) return "";
    return status
      .toString()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase())
      .replace(/\bSram\b/i, "SRAM")
      .replace(/\bDnd\b/i, "DND");
  };

  const getStatusIcon = (status) => {
    if (!status) return <FiUser />;
    const icons = {
      new: <FiUserCheck />,
      contacted: <FiPhoneCall />,
      interested: <FiTrendingUp />,
      not_interested: <FiUserX />,
      call_back: <FiRefreshCw />,
      demo_scheduled: <FiCalendar />,
    };
    return icons[status.toLowerCase()] || <FiTag />;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    try {
      const date = new Date(dateStr.replace(" ", "T"));
      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return dateStr;
    }
  };

  // Fixed category filter: trim and lowercase for accurate comparison
  const filteredData = useMemo(() => {
    const term = searchTerm.toLowerCase().trim();
    return data.filter((lead) => {
      let matchesSearch = true;
      let matchesCategory = true;

      if (term) {
        matchesSearch =
          lead.name?.toLowerCase().includes(term) ||
          lead.phone?.includes(term) ||
          lead.email?.toLowerCase().includes(term) ||
          lead.id?.toString().includes(term);
      }

      if (filters.category) {
        const leadCategory = (lead.category_name || "").trim().toLowerCase();
        const filterCategory = filters.category.trim().toLowerCase();
        matchesCategory = leadCategory === filterCategory;
      }

      let matchesSource = true;
      if (filters.source) {
        matchesSource = lead.source?.toLowerCase() === filters.source.toLowerCase();
      }

      return matchesSearch && matchesCategory && matchesSource;
    });
  }, [data, searchTerm, filters.category, filters.source]);

  const totalPages = Math.ceil(filteredData.length / limit);
  const paginatedData = useMemo(() => {
    const start = (page - 1) * limit;
    return filteredData.slice(start, start + limit);
  }, [filteredData, page, limit]);

  useEffect(() => {
    setPage(1);
  }, [limit]);

  const clearFilters = () => {
    setFilters({
      from: "",
      to: "",
      status: "",
      user_id: "",
      tm_id: "",
      lead_id: "",
      user_name: "",
      category: "",
      source: "",
    });
    setSearchTerm("");
    setPage(1);
  };

  const exportToCSV = () => {
    const headers = ["ID", "Name", "Phone", "Email", "Status", "Category", "Created At", "Discussion", "Remark"];
    const csvData = filteredData.map(lead => [
      lead.id,
      lead.name,
      lead.phone,
      lead.email,
      lead.status,
      lead.category_name || "",
      lead.created_at,
      lead.discussion || "",
      lead.remark || ""
    ]);
    
    const csvContent = [headers, ...csvData].map(row => row.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `leads_report_${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const getActiveFiltersCount = () => {
    return Object.values(filters).filter(v => v && v !== "").length + (searchTerm ? 1 : 0);
  };

  const formatAssignedUsers = (users) => {
    if (!users || users.length === 0) return "-";
    return users.map(u => `${u.name} (${u.type})`).join(", ");
  };

  const getAgentName = (lead) => {
    const callDetails = lead.call_details;
    if (!callDetails || !callDetails.call_user_id) return "-";
    const agentId = callDetails.call_user_id;
    const assigned = lead.assigned_to || [];
    const agent = assigned.find(u => u.id === agentId && u.type === "sales");
    return agent ? agent.name : `Agent ID: ${agentId}`;
  };

  const formatCallTime = (timeStr) => {
    if (!timeStr) return "-";
    try {
      const date = new Date(timeStr.replace(" ", "T"));
      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
    } catch {
      return timeStr;
    }
  };

  const formatFollowupTextAndNote = (lead) => {
    let text = "-";
    let note = "-";

    if (lead.last_followup) {
      text = lead.last_followup.text || "-";
      note = lead.last_followup.note || "-";
    } else {
      text = lead.discussion || "-";
      note = lead.remark || "-";
    }

    return (
      <div className="followup-details">
        <div><strong>Text:</strong> {text}</div>
        <div><strong>Note:</strong> {note}</div>
      </div>
    );
  };

  return (
    <div className="lead-container">
      <div className="lead-header">
        <div className="header-title">
          <h3>Leads Management Dashboard</h3>
          <p className="subtitle">Track and manage all your leads in one place</p>
        </div>
        <div className="header-actions">
          <button className="btn-refresh" onClick={fetchData}>
            <FiRefreshCw /> Refresh
          </button>
        </div>
      </div>

      <div className="search-section">
        <div className="search-wrapper">
          <FiSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search by name, phone, email or lead ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          {searchTerm && (
            <button className="clear-search" onClick={() => setSearchTerm("")}>
              <FiX />
            </button>
          )}
        </div>
        <button 
          className={`filter-toggle ${showFilters ? "active" : ""}`}
          onClick={() => setShowFilters(!showFilters)}
        >
          <FiFilter /> Filters
          {getActiveFiltersCount() > 0 && (
            <span className="filter-badge">{getActiveFiltersCount()}</span>
          )}
        </button>
      </div>

      {showFilters && (
        <div className="filters-section">
          <div className="filters-grid">
            <div className="filter-group">
              <FiCalendar className="filter-icon" />
              <input
                type="date"
                name="from"
                value={filters.from}
                onChange={handleFilterChange}
                placeholder="From Date"
              />
            </div>
            <div className="filter-group">
              <FiCalendar className="filter-icon" />
              <input
                type="date"
                name="to"
                value={filters.to}
                onChange={handleFilterChange}
                placeholder="To Date"
              />
            </div>
            <div className="filter-group">
              <FiUser className="filter-icon" />
              <input
                type="text"
                name="user_name"
                placeholder="User Name"
                value={filters.user_name}
                onChange={handleFilterChange}
              />
            </div>
            <div className="filter-group">
              <FiTag className="filter-icon" />
              <select
                name="category"
                value={filters.category}
                onChange={handleFilterChange}
              >
                <option value="">All Categories</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.name}>
                    {cat.name}
                  </option>
                ))}
              </select>
            </div>
          <div className="filter-group">
            <FiTag className="filter-icon" />
            <select name="source" value={filters.source} onChange={handleFilterChange}>
              <option value="">All Sources</option>
              <option value="Website">Website</option>
              <option value="Facebook">Facebook</option>
              <option value="Google Ads">Google Ads</option>
              <option value="Reference">Reference</option>
            </select>
          </div>
          <div className="filter-group">
            <FiTag className="filter-icon" />
            <select name="status" value={filters.status} onChange={handleFilterChange}>
              <option value="">All Lead Status</option>
              {[...statuses].sort((a, b) => (a.name || "").localeCompare(b.name || "")).map((s) => (
                <option key={s.id} value={s.name.toLowerCase().replace(/\s+/g, "_")}>
                  {formatStatusLabel(s.name)}
                </option>
              ))}
            </select>
          </div>
          </div>
          <div className="filter-actions">
            <button className="btn-apply" onClick={fetchData} disabled={loading}>
              {loading ? "Loading..." : "Apply Filters"}
            </button>
            <button className="btn-clear" onClick={clearFilters}>
              Clear All
            </button>
          </div>
        </div>
      )}

      {teamMembers.length > 0 && (
        <div className="team-section">
          <div className="team-header">
            <FiUsers className="team-icon" />
            <span>Team Members ({teamMembers.length})</span>
          </div>
          <div className="team-members">
            {teamMembers.map((member, idx) => (
              <div key={idx} className={`team-badge role-${member.role}`}>
                {member.name} ({member.role})
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="summary-cards">
        <div className="summary-card">
          <div className="card-icon lead-icon">
            <FiUsers />
          </div>
          <div className="card-info">
            <span className="card-label">Total Leads</span>
            <span className="card-value">{summary.total_leads || 0}</span>
          </div>
        </div>
        <div className="summary-card">
          <div className="card-icon call-icon">
            <FiPhoneCall />
          </div>
          <div className="card-info">
            <span className="card-label">Total Calls</span>
            <span className="card-value">{summary.total_calls_count || 0}</span>
          </div>
        </div>
        <div className="summary-card">
          <div className="card-icon time-icon">
            <FiClock />
          </div>
          <div className="card-info">
            <span className="card-label">Total Duration</span>
            <span className="card-value">{summary.total_duration_formatted || "00:00:00"}</span>
          </div>
        </div>
        <div className="summary-card">
          <div className="card-icon team-icon">
            <FiUsers />
          </div>
          <div className="card-info">
            <span className="card-label">Team Size</span>
            <span className="card-value">{summary.team_size || 0}</span>
          </div>
        </div>
      </div>

      <div className="table-controls">
        <div className="entries-selector">
          <label>Show</label>
          <select value={limit} onChange={(e) => setLimit(Number(e.target.value))}>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <label>entries</label>
        </div>
        <div className="record-info">
          Showing {paginatedData.length} of {filteredData.length} leads
        </div>
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Loading leads...</p>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="report-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Lead Information</th>
                <th>Contact</th>
                <th>Status</th>
                <th>Category</th>
                <th>Discussion</th>
                <th>Remark</th>
                <th>Last Follow-up</th>
                <th>Assigned To</th>
                <th>Agent Name</th>
                <th>Call Start Time</th>
                <th>Call End Time</th>
                <th>Call Duration</th>
                <th>Pipeline Status</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((lead) => {
                  const callDetails = lead.call_details;
                  return (
                    <tr key={lead.id}>
                      <td className="lead-id">#{lead.id}</td>
                      <td>
                        <div className="lead-info">
                          <strong>{lead.name || "-"}</strong>
                          {lead.is_high_profile === 1 && <span className="premium-badge">Premium</span>}
                          {lead.source && <span className="source-badge">{lead.source}</span>}
                        </div>
                      </td>
                      <td>
                        <div className="contact-info">
                          <div><FiPhone /> {lead.phone || "-"}</div>
                          <div><FiMail /> {lead.email || "-"}</div>
                        </div>
                      </td>
                      <td>
                        <span className={`status-badge ${getStatusClass(lead.status)}`}>
                          {getStatusIcon(lead.status)}
                          {lead.status || "New"}
                        </span>
                      </td>
                      <td>{lead.category_name || "-"}</td>
                      <td className="text-cell">{lead.discussion || "-"}</td>
                      <td className="text-cell">{lead.remark || "-"}</td>
                      <td className="followup-cell">{formatFollowupTextAndNote(lead)}</td>
                      <td className="text-cell">{formatAssignedUsers(lead.assigned_to)}</td>
                      <td className="text-cell">{getAgentName(lead)}</td>
                      <td className="time-cell">
                        {callDetails ? formatCallTime(callDetails.start_time) : "-"}
                      </td>
                      <td className="time-cell">
                        {callDetails ? formatCallTime(callDetails.end_time) : "-"}
                      </td>
                      <td className="duration-cell">
                        {callDetails?.duration_formatted || "-"}
                      </td>
                      <td>
                        {callDetails?.call_status ? (
                          <span className={`pipeline-status-badge ${callDetails.call_status}`}>
                            {callDetails.call_status}
                          </span>
                        ) : "-"}
                      </td>
                      <td className="date-cell">{formatDate(lead.created_at)}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="15" className="no-data">
                    <FiSearch />
                    <p>No leads found</p>
                    <span>Try adjusting your filters or search criteria</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {totalPages > 1 && (
        <div className="pagination">
          <button onClick={() => setPage(1)} disabled={page === 1}>
            <FiChevronsLeft />
          </button>
          <button onClick={() => setPage(page - 1)} disabled={page === 1}>
            <FiChevronLeft />
          </button>
          <span className="page-info">
            Page {page} of {totalPages}
          </span>
          <button onClick={() => setPage(page + 1)} disabled={page === totalPages}>
            <FiChevronRight />
          </button>
          <button onClick={() => setPage(totalPages)} disabled={page === totalPages}>
            <FiChevronsRight />
          </button>
        </div>
      )}
    </div>
  );
};

export default LeadReportLayer;
